import type { PermissionCode } from '@clarix/shared-types';

/**
 * The hrms keys the shell gates on (rail items, panel rows). The shell may not import the
 * remote (root hard rule 1), so these mirror `P` in apps/hrms/src/permissions.ts exactly.
 */
export const HRMS_SHELL_PERM = {
  DASHBOARD_VIEW: 'hrms.dashboard.view',
  PROFILE_VIEW_OWN: 'hrms.profile.view.own',
  PEOPLE_VIEW: 'hrms.people.view',
  PEOPLE_MANAGE: 'hrms.people.manage',
  PREJOINING_VIEW: 'hrms.prejoining.view',
  ONBOARDING_TEMPLATES_MANAGE: 'hrms.onboarding.templates.manage',
  HOLIDAY_VIEW: 'hrms.holiday.view',
  SETTINGS_MANAGE: 'hrms.settings.manage',
  APPROVAL_VIEW: 'hrms.approval.view',
  ATTENDANCE_VIEW_OWN: 'hrms.attendance.view.own',
  ATTENDANCE_VIEW_TEAM: 'hrms.attendance.view.team',
  ATTENDANCE_VIEW_ALL: 'hrms.attendance.view.all',
  ATTENDANCE_VERIFY: 'hrms.attendance.verify',
  ATTENDANCE_POLICY_MANAGE: 'hrms.attendance.policy.manage',
  ATTENDANCE_ROSTER_MANAGE: 'hrms.attendance.roster.manage',
  OVERTIME_VIEW_OWN: 'hrms.overtime.view.own',
  OVERTIME_VIEW_TEAM: 'hrms.overtime.view.team',
  OVERTIME_VIEW_ALL: 'hrms.overtime.view.all',
  OVERTIME_POLICY_MANAGE: 'hrms.overtime.policy.manage',
  LEAVE_VIEW_OWN: 'hrms.leave.view.own',
  LEAVE_VIEW_TEAM: 'hrms.leave.view.team',
  LEAVE_VIEW_ALL: 'hrms.leave.view.all',
  LEAVE_SETUP_MANAGE: 'hrms.leave.setup.manage',
  LEAVE_EDIT: 'hrms.leave.edit',
  RBAC_VIEW: 'hrms.rbac.view',
} as const satisfies Record<string, PermissionCode>;

/** The hrms feature flags panel rows hide behind; a string-exact mirror of `HRMS_FLAG` in apps/hrms/src/flags.ts. */
export const HRMS_SHELL_FLAG = {
  LEAVE_TEAM_PAGES: 'HRMS_LEAVE_TEAM_PAGES',
  LEAVE_HR_TOOLS: 'HRMS_LEAVE_HR_TOOLS',
  LEAVE_YEAR_END: 'HRMS_LEAVE_YEAR_END',
  OVERTIME: 'HRMS_OVERTIME',
} as const;
